import { render } from "./Layout.vue?vue&type=template&id=0e03ce38"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sekou A Sidibe\\Documents\\NTA TECH\\projets\\backoffice_operation_mouton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__